import { pageLoadHook } from "./Clients/vodafone/Function";

export const FunctionMapper: Record<string, any> = {
  vodafone: {
    pageLoadHook: pageLoadHook
  }
};
